(() => {
  'use strict';
  // After publication and product-template assignment, remove only the view query here.
  const CONFIGURATOR_URL = '/products/custom-golf-impact-screen?view=custom-screen-builder';
  const url = (parameters) => {
    const target = new URL(CONFIGURATOR_URL, window.location.origin);
    if (parameters) new URLSearchParams(parameters).forEach((value, key) => {
      if (!['view', 'preview_theme_id'].includes(key)) target.searchParams.set(key, value);
    });
    // Preserve an explicitly supplied unpublished-theme preview, when present.
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) target.searchParams.set('preview_theme_id', preview);
    return target;
  };
  window.SimCaddyConfiguratorRouting = Object.freeze({url});
  const updateLinks = (root = document) => {
    const target = url();
    root.querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');
      let current;
      try { current = new URL(href, window.location.origin); } catch (_) { return; }
      if (href === '#simcaddy-configurator' || (current.origin === target.origin && current.pathname === target.pathname)) {
        const next = url(current.searchParams);
        link.href = next.href;
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => updateLinks());
  else updateLinks();
  document.addEventListener('shopify:section:load', event => updateLinks(event.target));
})();
